var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "glyphicons-basic",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "square-empty-remove",
    d: "M24.5,4H7.5A3.50424,3.50424,0,0,0,4,7.5v17A3.50424,3.50424,0,0,0,7.5,28h17A3.50424,3.50424,0,0,0,28,24.5V7.5A3.50424,3.50424,0,0,0,24.5,4ZM25,24.5a.50641.50641,0,0,1-.5.5H7.5a.50641.50641,0,0,1-.5-.5V7.5A.50641.50641,0,0,1,7.5,7h17a.50641.50641,0,0,1,.5.5ZM21.30328,13.52515,18.82843,16l2.47485,2.47485a.50007.50007,0,0,1,0,.70716L19.182,21.30328a.50007.50007,0,0,1-.70716,0L16,18.82843l-2.47485,2.47485a.50007.50007,0,0,1-.70716,0L10.69672,19.182a.50007.50007,0,0,1,0-.70716L13.17157,16l-2.47485-2.47485a.50007.50007,0,0,1,0-.70716L12.818,10.69672a.50007.50007,0,0,1,.70716,0L16,13.17157l2.47485-2.47485a.50007.50007,0,0,1,.70716,0L21.30328,12.818A.50007.50007,0,0,1,21.30328,13.52515Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareClose);
export default __webpack_public_path__ + "static/media/square-close.be83fc8f034e5046d3f627a8a629e4bf.svg";
export { ForwardRef as ReactComponent };